/**
 * @generated SignedSource<<a2a9a6c4bcd586044fc815666907fcfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AuthorFiltersInput = {
  clientId?: string | null;
  emailIContains?: string | null;
  exclude?: ReadonlyArray<string | null> | null;
  firstNameIContains?: string | null;
  isActive?: boolean | null;
  lastNameIContains?: string | null;
  only?: ReadonlyArray<string | null> | null;
  usernameIContains?: string | null;
};
export type FilterAndSortCreatedBy2FetchAllQuery$variables = {
  filters?: AuthorFiltersInput | null;
};
export type FilterAndSortCreatedBy2FetchAllQuery$data = {
  readonly viewer: {
    readonly authors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly userId: number;
        } | null;
      } | null>;
    } | null;
  } | null;
};
export type FilterAndSortCreatedBy2FetchAllQuery = {
  response: FilterAndSortCreatedBy2FetchAllQuery$data;
  variables: FilterAndSortCreatedBy2FetchAllQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Literal",
            "name": "section",
            "value": "ADMIN"
          }
        ],
        "concreteType": "AuthorNodeConnection",
        "kind": "LinkedField",
        "name": "authors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterAndSortCreatedBy2FetchAllQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterAndSortCreatedBy2FetchAllQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4248b9ac6f9209b962eedae5e6a97e5",
    "id": null,
    "metadata": {},
    "name": "FilterAndSortCreatedBy2FetchAllQuery",
    "operationKind": "query",
    "text": "query FilterAndSortCreatedBy2FetchAllQuery(\n  $filters: AuthorFiltersInput\n) {\n  viewer {\n    authors(filters: $filters, section: ADMIN) {\n      edges {\n        node {\n          id\n          userId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb1e0788acd0ab10c4ccb7998daa37d0";

export default node;
